import React from 'react';
import { X, Info, AlertCircle, CheckCircle } from 'lucide-react';

interface AlertWindowProps {
  message: string;
  type?: 'info' | 'success' | 'warning' | 'error';
  onDismiss: () => void;
  title?: string;
}

export const AlertWindow: React.FC<AlertWindowProps> = ({
  message,
  type = 'info',
  onDismiss,
  title
}) => {
  const icons = {
    info: <Info className="w-5 h-5" />,
    success: <CheckCircle className="w-5 h-5" />,
    warning: <AlertCircle className="w-5 h-5" />,
    error: <AlertCircle className="w-5 h-5" />
  };

  const colors = {
    info: 'bg-blue-500 border-blue-500 text-blue-100',
    success: 'bg-emerald-500 border-emerald-500 text-emerald-100',
    warning: 'bg-amber-500 border-amber-500 text-amber-100',
    error: 'bg-red-500 border-red-500 text-red-100'
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50"
        onClick={onDismiss}
      />

      {/* Alert */}
      <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50">
        <div className={`card p-6 max-w-sm w-full shadow-2xl border-l-4 ${colors[type]}`}>
          <div className="flex items-start gap-3">
            <div className={`p-2 rounded-lg ${colors[type].replace('text-', 'bg-') + '/20'}`}>
              {icons[type]}
            </div>

            <div className="flex-1 min-w-0">
              {title && (
                <h3 className="font-bold text-lg mb-1">{title}</h3>
              )}
              <p className="text-sm leading-relaxed">{message}</p>
            </div>

            <button
              onClick={onDismiss}
              className="ml-2 p-1 hover:bg-white/20 rounded-full transition-all"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
